import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { selectCountry } from "../../../../../store/HOC/genericUI.selectors";
import {
  selectIntroductoryApplicantData,
  selectUIData,
} from "../introductory.selectors";
import { setUIObjectField } from "../introductory.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.INTRODUCTORY_APPLICANT,
  selector: selectIntroductoryApplicantData,
  content: [
    {
      title: "Dane zgłaszającego",
      sections: [
        {
          id: "introductory-applicant-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_NAME,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_SURNAME,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: "introductory-applicant-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("applicantphone"),
              id: ComponentId.APPLICANT_PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_EMAIL,
              label: "Email",
            },
          ],
        },
      ],
    },
  ],
};
